export default __webpack_public_path__ + "static/media/close.4db43e4f.svg";